import { render, staticRenderFns } from "./MessagesListComponent.vue?vue&type=template&id=6372d2fa"
import script from "./MessagesListComponent.vue?vue&type=script&lang=js"
export * from "./MessagesListComponent.vue?vue&type=script&lang=js"
import style0 from "./MessagesListComponent.vue?vue&type=style&index=0&id=6372d2fa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports